<template>
    <div class="page">
        <Breadcrumb title="平台设置" :breadcrumb="breadcrumb" />
        <div class="content">
            <!-- 创建应用 -->
            <blue-title>基本信息</blue-title>
            <!-- 创建表单 -->
            <el-form :model="applyDetail" ref="applyDetail" label-position="left" label-width="100px" class="applyDetail">
                <el-form-item label="应用ID" prop="applyId">
                    <span>{{ applyDetail.applyId }}</span>
                </el-form-item>
                <el-form-item label="应用密钥">
                    <span class="key" @click="copyKey">复制密钥</span>
                </el-form-item>
                <el-form-item label="应用Code" prop="applyCode">
                    <span>{{ applyDetail.applyCode }}</span>
                </el-form-item>
                <el-form-item label="应用名称" prop="applyName">
                    <span>{{ applyDetail.applyName }}</span>
                </el-form-item>
                <el-form-item label="支付店铺名" prop="payName">
                    <span>{{ applyDetail.payName }}</span>
                </el-form-item>
                <el-form-item label="应用简介" prop="remark">
                    <span>{{ applyDetail.profile }}</span>
                </el-form-item>
                <el-form-item label="应用支付方式" prop="payType">
                    <span>{{ applyDetail.applyType==='HEEMONEY'?'汇付宝':'支付聚合平台' }}</span>
                </el-form-item>

                <blue-title class="ip">访问ip</blue-title>
                <el-form-item label="ip白名单" prop="ipList">
                    <div v-for="(item, index) in applyDetail.ipList" :key="index">
                        {{ item }}
                    </div>
                </el-form-item>
                <el-form-item class="form-footer">
                    <el-button type="primary" @click="goBack">返回首页</el-button>
                    <el-button @click="editForm">编辑</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { breadcrumb } from '@/mixins/index.js';
export default {
  mixins: [breadcrumb],
  data() {
    return {
      // 应用id
      id: '',
      // 详情
      applyDetail: {},
    };
  },
  methods: {
    ...mapActions('applyUpdate', ['queryApplyKey', 'getApplyDetail']),
    // 获取应用Key
    async copyKey() {
      // const { applyKey } = await this.getApplyDetail({ id: this.id });
      let oInput = document.createElement('input');
      oInput.value = this.applyDetail.applyKey;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      document.execCommand('Copy'); // 执行浏览器复制命令
      this.$message.success('复制成功');
      oInput.remove();
    },
    // 返回首页
    goBack() {
      this.$router.push({ name: 'apply/index' });
    },
    // 编辑
    editForm() {
      this.$router.push({ name: 'apply/update', query: { id: this.id } });
    },
    // 获取详情
    async getDetails() {
      let result = await this.getApplyDetail({ id: this.id });
      result.ipList = result.ipList.split(',');
      this.applyDetail = result;
    },
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getDetails();
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.page {
  width: 100%;
}
.content {
  margin-top: 15px;
  padding: 30px 30px 30px 15px;
  background: #fff;
}
.applyDetail {
  margin: 30px;
  .el-input {
    width: 70%;
  }
  .el-textarea {
    width: 70%;
  }
  /deep/.el-form-item__label {
    color: #999;
  }
  .form-footer {
    text-align: center;
    .el-button {
      width: 96px;
      height: 43px;
      border: 2px solid #4359b7;
      padding: 0;
      font-size: 16px;
    }
    .el-button:last-child {
      color: #4359b7;
      margin-left: 30px;
    }
  }
}
.ip {
  margin: 60px 0 20px -10px;
}
.add {
  width: 40px;
  height: 40px;
  width: 121px;
  color: #4359b7;
  border-color: #4359b7;
  font-size: 14px;
  padding: 10px 16px;
  margin-right: 40px;
}
.key {
  color: #4359b7;
  cursor: pointer;
}
</style>
